var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyActiveChatIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 150,
    viewBox: "0 0 382 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5555_50482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.642 145.457C332.642 106.879 317.317 69.8818 290.038 42.6033C262.76 15.3249 225.762 2.91252e-06 187.185 0C148.607 -2.91252e-06 111.61 15.3249 84.3313 42.6033C57.0529 69.8817 41.728 106.879 41.728 145.457L187.185 145.457H332.642Z",
    fill: "#F0F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.547 144.695V95.5562C127.547 93.5826 128.673 91.7817 130.446 90.9164L187.185 63.2393L238.296 90.8671C239.964 91.7687 241.004 93.5123 241.004 95.4085V144.695H127.547Z",
    fill: "#BBDFF5",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.675 72.828V101.82L180.776 131.482C182.603 132.868 185.124 132.883 186.967 131.519L226.04 102.603V55.2737H162.419C161.252 55.2737 160.119 55.6692 159.206 56.3957L143.624 68.7876C142.393 69.767 141.675 71.2545 141.675 72.828Z",
    fill: "white",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6372 144.547H278.823",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.459 144.547H338.46",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.171 144.547H372.692",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4548 144.547H17",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3637 144.547H1",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.675 101.957L128.769 92.9231",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.273 103.893L239.761 91.6326",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.821 144.547L195.88 125.188",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.064 144.547L172.649 125.833",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.295,
    cy: 84.534,
    r: 1.9359,
    fill: "#6A79A8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.235,
    cy: 84.5341,
    r: 1.9359,
    fill: "#6A79A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.034 56.1411V67.1112C161.034 69.9623 158.723 72.2736 155.872 72.2736H142.966",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.068 101.401C173.477 98.5633 178.288 96.7949 183.62 96.7949C188.951 96.7949 193.762 98.5633 197.171 101.401",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5555_50482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.675 91.6325H291.772H289.776C283.669 91.6325 283.582 96.3322 283.567 96.6337C283.26 98.1635 282.836 101.164 280.124 102.517C279.543 102.804 278.882 102.944 278.222 102.944H256.915C253.85 102.944 251.367 105.268 251.367 108.136C251.367 111.005 253.85 113.329 256.915 113.329H274.67C276.965 113.329 279.189 114.336 280.431 116.146C280.942 116.888 281.272 117.756 281.177 118.72C281.177 121.588 283.661 123.912 286.726 123.912H314.784C317.818 123.912 320.467 121.721 320.561 118.882C320.655 115.94 318.14 113.535 315.02 113.535H305.856C304.591 113.535 303.325 113.204 302.304 112.49C301.117 111.659 299.961 110.21 300.04 107.739C300.087 106.239 300.716 105.084 301.51 104.224C302.846 102.775 304.85 102.025 306.901 102.025H343.911C347.031 102.025 349.546 99.6124 349.452 96.6778C349.366 93.8242 346.717 91.6325 343.675 91.6325Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5555_50482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.1711 100.667H45.2675H43.2712C37.1645 100.667 37.078 105.366 37.0623 105.668C36.7558 107.198 36.3314 110.198 33.6199 111.552C33.0383 111.839 32.3781 111.978 31.7179 111.978H10.411C7.34588 111.978 4.8623 114.302 4.8623 117.171C4.8623 120.039 7.34588 122.363 10.411 122.363H28.1655C30.4604 122.363 32.6846 123.371 33.9264 125.18C34.4373 125.923 34.7674 126.791 34.6731 127.754C34.6731 130.622 37.1566 132.947 40.2218 132.947H68.2799C71.3136 132.947 73.9623 130.755 74.0566 127.916C74.1509 124.974 71.6359 122.569 68.5157 122.569H59.3516C58.0862 122.569 56.8209 122.238 55.7992 121.525C54.6124 120.694 53.457 119.245 53.5356 116.774C53.5828 115.273 54.2116 114.119 55.0054 113.258C56.3415 111.809 58.3456 111.059 60.3969 111.059H97.4069C100.527 111.059 103.042 108.647 102.948 105.712C102.861 102.859 100.213 100.667 97.1711 100.667Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5555_50482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 382,
    height: 150,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5555_50482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98.0855,
    height: 32.265,
    fill: "white",
    transform: "translate(251.376 91.6326)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5555_50482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98.0855,
    height: 32.265,
    fill: "white",
    transform: "translate(4.87158 100.667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyActiveChatIcn);
export default __webpack_public_path__ + "static/media/empty-active-chat-icn.3f6d83340c71507ea2211a72154292c9.svg";
export { ForwardRef as ReactComponent };